export const ForecastMaterialsApi = {
  material: '/material',
  materialInfo: '/material-info',
};
